import {
  LOAD_INFO,
  LOAD_INFO_FAIL,
  LOAD_INFO_SUCCESS,
  LoadInfo,
  LoadInfoFail,
  LoadInfoSuccess
} from '../actions/hosting-info.action';
import {InfoAction} from "../actions";

export interface IHostingEntityState {
  entities: {[websiteId: number]: any};
  loading: boolean;
  loaded: boolean;
}

export interface IHostingInfoState {
  entities: {[websiteId: number]: IHostingEntityState};
}

export const initialState: IHostingInfoState = {
  entities: {}
};

export function reducer(state: IHostingInfoState = initialState, action: InfoAction): IHostingInfoState {
  let payload: any;

  switch (action.type) {

    case LOAD_INFO:
      payload = (<LoadInfo>action).payload;

      return {
        ...state,
        entities: {
          ...state.entities,
          [payload]: {
            ...state[payload],
            loading: true,
            loaded: false
          }
        }
      };

    case LOAD_INFO_SUCCESS:
      payload = (<LoadInfoSuccess>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            entities: payload.entities,
            loading: false,
            loaded: true
          }
        }
      };

    case LOAD_INFO_FAIL:
      payload = (<LoadInfoFail>action).payload;

      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            loading: false,
            loaded: true
          }
        }
      };

  }

  return state;
}
